module.exports = __webpack_public_path__ + "img/fafang.b87404c5.svg";